import React from "react";

const MacroBarChart = ({ macroData }) => {
  const { macro, amount, target, streak } = macroData;
  const value = amount.value;
  const min = target?.min;
  const max = target?.max;

  // Colors matching the radial chart
  const mainGreen = "#598a56";
  const mainGreenDarker = "#3e6b3b";
  const redColor = "#ef4444";
  const backgroundGray = "#e5e7eb";

  // Calculate the bar segments and their widths
  const calculateBarSegments = () => {
    // Case 1: No target
    if (!target || (target && !min && !max)) {
      return [{ width: "100%", color: value !== 0 ? mainGreen : backgroundGray }];
    }

    // Case 2: Only min target
    if (min && !max) {
      if (value < min) {
        // Below min - partial fill
        const percentage = (value / min) * 100;
        return [{ width: `${percentage}%`, color: mainGreen }];
      } else {
        // Above min - two segments
        const minPercentage = (min / value) * 100;
        return [
          { width: `${minPercentage}%`, color: mainGreen },
          { width: `${100 - minPercentage}%`, color: mainGreenDarker },
        ];
      }
    }

    // Case 3: Only max target
    if (!min && max) {
      if (value <= max) {
        // Below max - partial fill
        const percentage = (value / max) * 100;
        return [{ width: `${percentage}%`, color: mainGreen }];
      } else {
        // Above max - two segments
        const maxPercentage = (max / value) * 100;
        return [
          { width: `${maxPercentage}%`, color: mainGreen },
          { width: `${100 - maxPercentage}%`, color: redColor },
        ];
      }
    }

    // Case 4: Both min and max targets
    if (min && max) {
      if (value < min) {
        // Below min - partial fill
        const percentage = (value / min) * 100;
        return [{ width: `${percentage}%`, color: mainGreen }];
      } else if (value <= max) {
        // Between min and max
        const minPercentage = (min / value) * 100;
        return [
          { width: `${minPercentage}%`, color: mainGreen },
          { width: `${100 - minPercentage}%`, color: mainGreenDarker },
        ];
      } else {
        // Above max - three segments
        const minPercentage = (min / value) * 100;
        const maxPercentage = ((max - min) / value) * 100;
        return [
          { width: `${minPercentage}%`, color: mainGreen },
          { width: `${maxPercentage}%`, color: mainGreenDarker },
          { width: `${100 - minPercentage - maxPercentage}%`, color: redColor },
        ];
      }
    }

    return [];
  };

  const barSegments = calculateBarSegments();
  return (
    <div>
      <div className="mt-2 h-3 w-full rounded-full bg-muted overflow-hidden">
        <div className="h-full flex rounded-full overflow-hidden">
          {barSegments.map((segment, index) => (
            <div
              key={index}
              className="h-full"
              style={{
                width: segment.width,
                backgroundColor: segment.color,
                borderRadius: 0,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MacroBarChart;
